module.exports = __webpack_public_path__ + "static/blog-11-4458820743614b9a3f0a8e3d56deadfb.png";